import { HTMLInputTypeAttribute, useCallback } from 'react';
import { SxProps, Theme } from '@mui/material';
import { useField } from 'formik';
import TextInputControlled from '../TextInputControlled';

interface TextInputProps {
  name: string;
  label?: string;
  isLabelMultiline?: boolean;
  placeholder?: string;
  disabled?: boolean;
  type?: HTMLInputTypeAttribute;
  tooltip?: string;
  suffix?: string;
  min?: number | Date;
  max?: number | Date;
  step?: number;
  pulsateError?: boolean;
  required?: boolean;
  allowZero?: boolean;
  autoFocus?: boolean;
  inputSx?: SxProps<Theme>;
}

function TextInput({ name, allowZero, ...props }: TextInputProps) {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField(
    name.toString(),
  );

  const onBlur = useCallback(() => setTouched(true), [setTouched]);

  const val =
    props.type === 'number' && (value === 0 || value === '0') && allowZero
      ? value
      : value || '';

  return (
    <TextInputControlled
      {...props}
      id={name.toString()}
      value={val}
      onChange={newValue => setValue(newValue)}
      onBlur={onBlur}
      isError={touched && !!error}
    />
  );
}

export default TextInput;
